var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "address",
      on: {
        click: function($event) {
          _vm.creating = true
        }
      }
    },
    [
      _c("span", { staticClass: "plus" }, [_vm._v("+")]),
      _vm._v(" "),
      _c("span", { staticClass: "text" }, [_vm._v("Adicionar novo endereço")]),
      _vm._v(" "),
      _vm.creating
        ? _c("NewAddress", {
            attrs: { user: { type: _vm.userType, id: _vm.userAccountableId } },
            on: {
              close: function($event) {
                _vm.creating = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b1f5058", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b1f5058","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/Address/NewAddress.vue
// module id = null
// module chunks = 